import React, { useState } from 'react';
import { Smile } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const EMOJI_CATEGORIES = {
  '🚗': ['🚗','🏎️','🚙','🚕','🚓','🚐','🛻','🚚','🏍️','🛞','⛽','🛣️','🏁','🏆','🥇','🎖️','🏅','🚦','🔧','🛠️','🧰','⚙️'],
  '😀': ['😀','😁','😂','🤣','😅','😍','🥰','😘','😎','🤩','🥳','😏','🤔','😴','🙄','😭','😤','😡','🥶','🥵','🤯','🤤','😈','💀','👻','🤖','🎃'],
  '👍': ['👍','👎','👌','✌️','🤞','🤟','🤘','🤙','👊','🙌','👏','🫡','🫶','💪','🙏','👀','🫦','👋','🤝','🖖'],
  '❤️': ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','🔥','⭐','✨','💫','⚡','🌟','💥','💯','🎉','🎊'],
  '🌆': ['🌆','🌇','🌃','🌉','🏙️','🌅','🌄','🏔️','⛰️','🌋','🗻','🏕️','🏖️','🏜️','🏝️','🌊','🌲','🌳','🌴','🍁','🍂','🍃','☀️','🌙','⭐','☁️','🌧️','⛈️','🌈','❄️','💨'],
  '📷': ['📷','📸','🎥','📹','🎬','🖼️','🎨','🎮','🕹️','🎯','🎲','🎤','🎧','🎵','🎶','📍','📌','🚀','✈️','🛸'],
};

export default function EmojiPicker({ onPick, side = 'top', align = 'end', testId = 'emoji-picker' }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(Object.keys(EMOJI_CATEGORIES)[1]); // default 😀
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testId}-trigger`}
          aria-label="Emoji"
          className="inline-grid place-items-center w-9 h-9 rounded-full text-white/60 hover:text-[#FFD479] hover:bg-white/5 transition"
        >
          <Smile className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side={side}
        align={align}
        className="w-72 p-2 bg-[#0F0F12] border border-white/10 text-white"
        data-testid={`${testId}-panel`}
      >
        <div className="flex gap-1 mb-2 overflow-x-auto pb-1">
          {Object.keys(EMOJI_CATEGORIES).map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setTab(c)}
              data-testid={`${testId}-tab-${c}`}
              className={`w-9 h-8 rounded-md text-lg leading-none grid place-items-center transition ${tab === c ? 'bg-white/10' : 'hover:bg-white/5'}`}
            >
              <span>{c}</span>
            </button>
          ))}
        </div>
        <div className="grid grid-cols-7 gap-1 max-h-56 overflow-y-auto">
          {EMOJI_CATEGORIES[tab].map((e, i) => (
            <button
              key={`${e}-${i}`}
              type="button"
              data-testid={`${testId}-emoji-${e}`}
              onClick={() => { onPick(e); setOpen(false); }}
              className="w-9 h-9 grid place-items-center text-xl leading-none rounded-md hover:bg-white/10 transition"
              aria-label={e}
            >
              {e}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
